var render = function (_h,_vm) {var _c=_vm._c;return (!_vm.props.item.subMenu)?_c('AMenuItem',{key:_vm.props.item.id,attrs:{"title":!_vm.props.item.parentMenu.length && _vm.props.item.name}},[_c('MenuContent',{attrs:{"item":_vm.props.item,"is-collapsed":_vm.props.isCollapsed}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }